export const search = {
  Songs: 'Songs',
  Playlists: 'Playlists',
  'Top Result': 'Top Result',
  'No results': 'No results',
  'No results where found for': 'No results where found for',
};
